import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Sound } from "@pixi/sound";
export class MusicResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("MusicResourcePackage");
    }
    public get assets_music_CityVerse_BG_Music_02_mp3(): Sound {
        return this.resource<Sound>("assets/music/CityVerse_BG_Music_02.mp3");
    }
}

